import React, { lazy, Suspense, useEffect, useState } from 'react';
import DraggableModal from '../DraggableModal/DraggableModal';
import {
  calculateSpeedKmH,
  ELRCConnectionStatus,
  ELRCMessageContentKeys,
  LRCPropsType,
  lrcState,
  LRCState,
  mergedColumns,
  TableItem,
} from './lrc.config';
import styles from './lrc.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { connectToFederation } from 'src/app/helpers/socket.helper';
import { EMesajAltTipi } from 'src/types/components/socket.type';
const MapComponent = lazy(() => import('src/app/components/MapComponent/MapComponent'));
import { MapViewState } from 'src/enums/map.enum';
import { HLAUnit, HlaMapUnit } from 'src/types/unit.type';
import { EAlgiDurumu } from 'src/enums/mixed.enum';
import { radianToDegree } from 'src/app/utils/mapUtil';
import { eventActions, unitsActions } from 'src/app/redux/actions';
import { getEnumKeyByValue } from 'src/app/helpers/enum.helper';
import { defaultDraggableModalPropsForMapComponent } from '../DraggableModal/draggable-modal.config';
import { statusHelper } from 'src/app/helpers';
import { useTranslation } from 'react-i18next';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
import Button from 'antd/es/button';
import Switch from 'antd/es/switch';
import message from 'antd/es/message';
import Table from 'antd/es/table/Table';

const LRC: React.FC<LRCPropsType> = ({ onClickOpen, setOnClickOpen }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { hymotsDB, HLAContent } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { hlaUnits, hlaMapUnits } = useSelector((state: reduxRootTypes.RootStateType) => state.unitsState);

  const [lrcConfig, setLrcConfig] = useState<LRCState>(lrcState);
  const [lrcStatus, setLrcStatus] = useState<ELRCConnectionStatus | undefined>();
  const [isAnyError, setIsAnyError] = useState(false);
  const [mapModal, setMapModal] = useState<boolean>(false);
  const [tableData, setTableData] = useState<TableItem[]>([]);

  const onFormSave = (connectStatus: 'connect' | 'disconnect') => {
    setLrcStatus(ELRCConnectionStatus.LOADING);
    if (connectStatus === 'connect') {
      const isError = Object.entries(lrcConfig)
        .filter((o) => o[0] !== 'rtiPort')
        .some((o) => o[1] === '' || o === null);

      if (isError) {
        setLrcStatus(ELRCConnectionStatus.DISCONNECTED);

        if (isError) {
          setIsAnyError(true);
        }

        return;
      }
    }

    if (hymotsDB) {
      connectToFederation(hymotsDB, connectStatus === 'connect' ? { ...lrcConfig } : {}, connectStatus);
    } else {
      message.error('You must select a hymots database to connect to the federation.');
    }
  };

  useEffect(() => {
    if (HLAContent) {
      if (HLAContent.mesajAltTipi === EMesajAltTipi.LRC_RTI_BAGLANTISI_TAMAMLANDI) {
        setLrcStatus(ELRCConnectionStatus.CONNECTED);
        statusHelper.displaySuccessStatusMessage(t('success.connectedToFederation'));
        setLrcConfig(HLAContent.icerik);
        setTableData(
          Object.entries(HLAContent.icerik)
            .filter((o) => o[0] !== 'federasyonOlusturulacak' && o[0] !== 'rtiPort')
            .map((o) => ({ module: getEnumKeyByValue(ELRCMessageContentKeys, o[0]), status: (o[1] as string) || '-' })),
        );
      }

      if (HLAContent.mesajAltTipi === EMesajAltTipi.LRC_RTI_BAGLANTISI_KULLANICI_TARAFINDAN_KESILDI) {
        setLrcStatus(ELRCConnectionStatus.DISCONNECTED);
        statusHelper.displaySuccessStatusMessage(t('success.disconnected'));
        dispatch(eventActions.hlaContentChanged(undefined));
      }

      if (
        HLAContent.mesajAltTipi === EMesajAltTipi.FEDERASYON_OLUSTURMA_BASARISIZ ||
        HLAContent.mesajAltTipi === EMesajAltTipi.LRC_RTI_BAGLANTISI_BASARISIZ ||
        HLAContent.mesajAltTipi === EMesajAltTipi.FEDERASYONA_KATILMA_BASARISIZ
      ) {
        setLrcStatus(ELRCConnectionStatus.DISCONNECTED);
        statusHelper.displayErrorMessage(t('errors.errorWhileConnectingToServer'));
        dispatch(eventActions.hlaContentChanged(undefined));
      }
    }
  }, [HLAContent]);

  const HLAUnitToMapUnit = (HLAUnit: HLAUnit, index: number): HlaMapUnit => {
    const newMapUnit: HlaMapUnit = {
      id: index + 1,
      uuid: HLAUnit.uuid,
      unitType: 'hla',
      algiDurumu: EAlgiDurumu.Self,
      sidc: HLAUnit.sidc.split(':')[1],
      kisaIsim: HLAUnit.kisaIsim,
      angajmanKurali: HLAUnit.angajmanKurali,
      kisaIsimOrg: HLAUnit.kisaIsim,
      uzunIsim: HLAUnit.kisaIsim,
      owner: HLAUnit.owner,
      rotaSirasi: 0,
      echelon: HLAUnit.echelon,
      forceIdentifier: HLAUnit.forceIdentifier,

      uzunIsimOrg: HLAUnit.kisaIsim,
      etkinlik: {
        disiplinVeMoralParametresi: HLAUnit.disiplinMoralYuzdesi,
        egitimSeviyesiParametresi: 0,
        meskunMahalParametresi: 0,
      },
      konum: {
        lat: HLAUnit.spatialFP.konum.latitude,
        lng: HLAUnit.spatialFP.konum.longitude,
        alt: HLAUnit.spatialFP.konum.altitude,
      },
      istikamet: radianToDegree(HLAUnit.spatialFP.oryantasyon.psi),
      hiz: calculateSpeedKmH(HLAUnit.spatialFP.velocity),
      hacim: {
        uzunluk: HLAUnit.hacim.uzunluk,
        yukseklik: HLAUnit.hacim.yukseklik,
        genislik: HLAUnit.hacim.genislik,
      },
      isActive: true,
    };

    return newMapUnit;
  };

  useEffect(() => {
    if (hlaUnits.length > 0) {
      const newMapUnits = hlaUnits.map((HLAUnit, index) => {
        return HLAUnitToMapUnit(HLAUnit, index);
      });

      dispatch(unitsActions.setHlaMapUnits(newMapUnits));
    } else {
      dispatch(unitsActions.setHlaMapUnits([]));
    }
  }, [hlaUnits]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (lrcStatus === ELRCConnectionStatus.CONNECTED) return;

      if (e.key === 'Enter') {
        onFormSave('connect');
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClickOpen, onFormSave]);

  return (
    <>
      {onClickOpen && (
        <DraggableModal
          headerText={t('LRC.localRtiComponent')}
          onClickClose={() => setOnClickOpen(false)}
          style={{ width: '740px', height: '40vh' }}
        >
          <Form initialValues={lrcConfig} form={form} scrollToFirstError={{ behavior: 'smooth' }}>
            <div className="popup-main-container">
              <div className="popup-container">
                <div className="popup-content" style={{ padding: 0, height: '25vh' }}>
                  <div className={styles.container}>
                    {lrcStatus === ELRCConnectionStatus.CONNECTED ? (
                      <Table bordered dataSource={tableData} columns={mergedColumns} pagination={false} size="small" />
                    ) : (
                      <div className="popup-row grid-col-2-fixed">
                        <div className="popup-input-container-private" style={{ position: 'relative', height: 80 }}>
                          <span className="popup-input-title">{t('LRC.federationName')}</span>
                          <Input
                            className={styles.standard_input}
                            value={lrcConfig?.federationName || ''}
                            onChange={(e) => setLrcConfig((prev) => ({ ...prev, federationName: e.target.value }))}
                            placeholder={t('LRC.federationName') || ''}
                          />
                          {isAnyError && lrcConfig.federationName === '' && (
                            <p style={{ color: 'red', position: 'absolute', bottom: 0, left: 0, margin: 0 }}>
                              {t('LRC.nameCannotBeEmpty')}
                            </p>
                          )}
                        </div>
                        <div className="popup-input-container-private" style={{ position: 'relative', height: 80 }}>
                          <span className="popup-input-title">{t('LRC.federateName')}</span>
                          <Input
                            className={styles.standard_input}
                            value={lrcConfig.federateName || ''}
                            onChange={(e) => setLrcConfig((prev) => ({ ...prev, federateName: e.target.value }))}
                            placeholder={t('LRC.federateName') || ''}
                          />
                        </div>
                        <div className="popup-input-container-private" style={{ position: 'relative', height: 80 }}>
                          <span className="popup-input-title">{t('LRC.rtiHost')}</span>
                          <Input
                            className={styles.standard_input}
                            value={lrcConfig.rtiHost || ''}
                            onChange={(e) => setLrcConfig((prev) => ({ ...prev, rtiHost: e.target.value }))}
                            placeholder={t('LRC.rtiHost') || ''}
                          />
                          {isAnyError && lrcConfig.rtiHost === '' && (
                            <p style={{ color: 'red', position: 'absolute', bottom: 0, left: 0, margin: 0 }}>
                              {t('LRC.hostCannotBeEmpty')}
                            </p>
                          )}
                        </div>
                        <div className="popup-switch-container">
                          <span className="popup-input-title">{t('LRC.createFederation')}</span>
                          <Switch
                            style={{ width: '20%' }}
                            checked={lrcConfig.federasyonOlusturulacak}
                            onChange={(e) => setLrcConfig((prev) => ({ ...prev, federasyonOlusturulacak: e }))}
                            className="custom-switch"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.lrc_popup_footer} style={{ marginTop: '2%' }}>
              <div>
                {lrcStatus === ELRCConnectionStatus.CONNECTED && (
                  <button onClick={() => setMapModal(true)} className="next-button">
                    MAP VIEW
                  </button>
                )}
              </div>

              <div>
                {lrcStatus === ELRCConnectionStatus.CONNECTED && (
                  <button
                    type="button"
                    className={lrcStatus === ELRCConnectionStatus.CONNECTED ? `${styles.lrc_button}` : 'modal-button'}
                    onClick={() => onFormSave('disconnect')}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    {t('LRC.disconnect')}
                  </button>
                )}
                {lrcStatus !== ELRCConnectionStatus.CONNECTED && (
                  <Button
                    className="next-button"
                    onClick={() => onFormSave('connect')}
                    loading={lrcStatus === ELRCConnectionStatus.LOADING}
                    onKeyDown={(e) => e.key === 'enter' && onFormSave('connect')}
                  >
                    {t('LRC.connect')}
                  </Button>
                )}
              </div>
            </div>
          </Form>
        </DraggableModal>
      )}
      {mapModal && (
        <div className={styles.mapViewer}>
          <DraggableModal
            headerText="Map View"
            onClickClose={() => setMapModal(false)}
            defaultPosition={{ x: 550, y: -10 }}
            className={styles.mapDrag}
            {...defaultDraggableModalPropsForMapComponent}
          >
            <Suspense fallback={<div>loading...</div>}>
              <MapComponent mapViewState={MapViewState.Default} unitsSelected={hlaMapUnits} />
            </Suspense>
          </DraggableModal>
        </div>
      )}
    </>
  );
};

export default LRC;
